import { Decorate } from './types';
import { AxiosError, AxiosRequestConfig } from 'axios';
import globalAlertStore from '@/store/common/global-alert';

// URLs that need network status checking
const NETWORK_CHECK_PATHS = [
  '/wmp-bff/sso/big-loyalty-api-key',
  //   'api/data/get?uuid=',
  '/fp/checkout/v3/initiate',
];

/*
 * NetworkCheck Decorator
 */
export default class NetworkCheck extends Decorate {
  private needsNetworkCheck(url: string): boolean {
    return NETWORK_CHECK_PATHS.some((path) => url.includes(path));
  }

  private isNetworkError(error: AxiosError): boolean {
    const status = error.response?.status;

    // No status code or status code not in 100-599 range indicates network error
    return !status || status < 100 || status > 599;
  }

  /**
   * Show network error dialog to user
   */
  private showNetworkErrorMessage(): void {
    globalAlertStore.showAlert({
      translation: {
        title: '网络异常',
        subTitle: '当前网络不稳定，请检查网络连接或切换网络后重试',
        primaryButtonTitle: '确定',
      },
      primaryHandleClick: () => {
        globalAlertStore.hideAlert();
      },
    });
  }

  async error(err: AxiosError, request: (config: AxiosRequestConfig) => any) {
    const url = this.requestConfig?.url;

    // Check if this URL needs network checking and if it's a network error
    if (this.needsNetworkCheck(url) && this.isNetworkError(err)) {
      this.showNetworkErrorMessage();
    }

    throw err;
  }
}
